import React, { Component } from 'react';
import { renderRoutes } from 'react-router-config';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Cookies from 'universal-cookie';
import Loader from './loader';
import LayoutPriv from './layoutpriv';
import LayoutPub from './layoutpub';
import LayoutStandard from './layoutstandard';
import Modal from './modal';
import TermsModal from './termsmodal';
import { UsersnapProvider } from './usersnap';
import * as Sentry from '@sentry/react';

import {
  fetchMe,
} from '../actions';

const cookies = new Cookies();

class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalComponent: null,
      navOpen: false,
    };
    this.toggleNav = this.toggleNav.bind(this);
    this.checkTerms = this.checkTerms.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.setSentryData = this.setSentryData.bind(this);

    const userAgent = window.navigator.userAgent;
    const platform = window.navigator.platform;
    const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
    const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
    const iosPlatforms = ['iPhone', 'iPad', 'iPod'];
    let os = 'unset';

    if (macosPlatforms.indexOf(platform) !== -1) {
      os = 'mac';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = 'ios';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = 'windows';
    } else if (/Android/.test(userAgent)) {
      os = 'android';
    } else if (!os && /Linux/.test(platform)) {
      os = 'linux';
    }

    if (os === 'windows') {
      require('./scrollstyle.css');
    }
  }

  componentDidMount() {
    const { dispatch, user } = this.props;
    const { pathname } = this.props.location;

    if (pathname === '/validate') {
      return;
    }

    dispatch(fetchMe())
      .then((res) => {
        if (res.type === 'FETCH_ME_SUCCESS') {
          this.checkTerms();
          this.setSentryData();
        }
      });
  }

  setSentryData() {
    const { user } = this.props;
    const { email } = user.me;
    if (user && user.me) {
      Sentry.setUser({ email: email });
    }
  }

  checkTerms() {
    const { user } = this.props;
    let termsAgreed;
    if (user && user.me) {
      if (Number(user.me.termsVersion) !== Number(process.env.REACT_APP_TERMS_VERSION)) {
        this.toggleModal(<TermsModal toggleModal={this.toggleModal} modalComponent={this.state.modalComponent} />)
      }
    }
  }

  toggleModal(component) {
    this.setState({
      modalComponent: component,
    });
  }

  toggleNav() {
    this.setState({
      navOpen: !this.state.navOpen,
    });
  }

  render() {
    const { pathname } = this.props.location;
    const { user, loading } = this.props;
    const { navOpen } = this.state;
    const vto = cookies.get('_vto');
    const vtoa = cookies.get('_vtoa');

    let loggedIn;

    if (user && user.me && (user.me && Object.keys(user.me).length !== 0 && user.me.constructor === Object)) {
      loggedIn = true;
    }

    // TODO
    let tradingDisabled;

    const userBlocked = user && user.me && user.me.flags && user.me.flags.ordersBlocked;
    const userVerified = user && user.me && user.me.flags && user.me.flags.verified;
    const emailVerified = user && user.me && user.me.emailVerified;

    let loggedOutPage;
    let publicPage;
    let standardPage;

    switch (pathname) {
      case '/login':
        loggedOutPage = true;
        break;
      case '/register':
        loggedOutPage = true;
        break;
      case '/validate': // this is probably wrong
          loggedOutPage = true;
          break;
      case '/forgot-password':
        loggedOutPage = true;
        break;
      case '/password/reset':
        loggedOutPage = true;
        break;
      case '/verify-email':
        loggedOutPage = true;
        break;
      case '/change-email':
        loggedOutPage = true;
        break;
      case '/verify-ip':
        loggedOutPage = true;
        break;
      case '/recover':
        loggedOutPage = true;
        break;
      case '/reverify':
        publicPage = true;
        break;
      case '/reset-two-factor':
        loggedOutPage = true;
        break;
      case '/verify-two-factor':
        loggedOutPage = true;
        break;
      case '/oauth/redirect':
        loggedOutPage = true;
        break;
      case '/standard':
        standardPage = true;
        break;
      default:
        break;
    }

    let userData;
    if (user && user.me) {
      const { referenceId, email } = user.me;
      userData = {
        custom: {
          referenceId : referenceId,
        },
        user: {
          email: email,
        }
      };
    }

    if (loggedOutPage && loggedIn) {
      window.location.href = '/';
    }

    if (!loggedIn && loggedOutPage) {
      return (
        <LayoutPub
          routes={this.props.route.routes}
          userBlocked={userBlocked}
          loggedIn={loggedIn}
        />
      );
    }

    if (publicPage && (!vto && !vtoa)) {
      return (
        <LayoutPub
          routes={this.props.route.routes}
          userBlocked={userBlocked}
          loggedIn={loggedIn}
        />
      );
    }

    if (publicPage) {
      return (
        <LayoutPub
          routes={this.props.route.routes}
          userBlocked={userBlocked}
          loggedIn={loggedIn}
        />
      );
    }

    if (standardPage && loggedIn) {
      return (
        <>
          <UsersnapProvider initParams={userData}>
            {this.state.modalComponent &&
              <Modal noclose toggleModal={this.toggleModal} modalComponent={this.state.modalComponent} />
            }
            <LayoutStandard
              routes={this.props.route.routes}
              toggleNav={this.toggleNav}
              userBlocked={userBlocked}
              userVerified={userVerified}
              emailVerified={emailVerified}
              tradingDisabled={tradingDisabled}
              navOpen={navOpen}
              loggedIn={loggedIn}
            />
          </UsersnapProvider>
        </>
      );
    }

    if (loggedIn) {
      return (
        <>
          <UsersnapProvider initParams={userData}>
            {this.state.modalComponent &&
              <Modal noclose toggleModal={this.toggleModal} modalComponent={this.state.modalComponent} />
            }
            <LayoutPriv
              routes={this.props.route.routes}
              toggleNav={this.toggleNav}
              userBlocked={userBlocked}
              userVerified={userVerified}
              emailVerified={emailVerified}
              tradingDisabled={tradingDisabled}
              navOpen={navOpen}
              loggedIn={loggedIn}
            />
          </UsersnapProvider>
        </>
      );
    }

    return (
      <div className="page-wrapper">
        <div className="content-wrapper">
          <div className="login-container">
            <div className="center-loader">
              <Loader logo />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  loading: state.user.loading,
});

export default withRouter(connect(mapStateToProps)(Layout));
